exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".snackbar[data-v-0cd04481]{font-size:20px}", ""]);

// exports
